import Widget from './Widget'
import styles from './WidgetCalendar.module.css'
import { useTranslationUpdate } from '../../hooks/useTranslationUpdate'
import { getCurrentLanguage } from '../../translations'

export default function WidgetCalendar() {
    useTranslationUpdate()
    const currentLang = getCurrentLanguage()
    
    const today = new Date()
    const year = today.getFullYear()
    const month = today.getMonth()
    const date = today.getDate()

    const firstDay = new Date(year, month, 1).getDay()
    const lastDate = new Date(year, month + 1, 0).getDate()

    const days = []
    for (let i = 0; i < firstDay; i++) days.push(null)
    for (let d = 1; d <= lastDate; d++) days.push(d)

    const daysOfWeek = Array.from({ length: 7 }, (_, i) => {
        const date = new Date(2023, 9, 1 + i) 
        return date.toLocaleDateString(currentLang, { weekday: 'short' }).charAt(0).toUpperCase()
    })

    const monthName = today.toLocaleString(currentLang, { month: 'long' }).toUpperCase()

    return (
        <Widget size="small">
            <div className={styles.calendar}>
                <div className={styles.header}>{monthName}</div>
                <div className={styles.week}>
                    {daysOfWeek.map((d, i) => (
                        <span key={i} className={styles.weekday}>{d}</span>
                    ))}
                </div>
                <div className={styles.days}>
                    {days.map((d, i) => (
                        <span
                            key={i}
                            className={`
        ${styles.day}
        ${d === date ? styles.today : ''}
        ${(i % 7 === 0 || i % 7 === 6) ? styles.weekend : ''}
      `}
                        >
                            {d ?? ''}
                        </span>
                    ))}
                </div>
            </div>
        </Widget>
    )
}
